__webpack_require__.p = "/product-updates-demo/referrals-hub/";